var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { CertificadosService } from 'src/app/services/certificados.service';
import { UserService } from 'src/app/services/user.service';
import * as FormActions from '../../reducers/actions/forms.actions';
import { MatDialog, MatSnackBar } from '@angular/material';
import { PerfilComponent } from '../perfil/perfil.component';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
var ValidarCertificadosComponent = /** @class */ (function () {
    function ValidarCertificadosComponent(_cert, spinner, activatedRoute, _userService, _router, store, snackBar, dialog, claveUnicaService) {
        var _this = this;
        this._cert = _cert;
        this.spinner = spinner;
        this.activatedRoute = activatedRoute;
        this._userService = _userService;
        this._router = _router;
        this.store = store;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.claveUnicaService = claveUnicaService;
        this.cod = new FormControl('', [Validators.required]);
        this.activatedRoute.params.subscribe(function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log("parametros ruta", params);
                        _a = this;
                        return [4 /*yield*/, params['cod']];
                    case 1:
                        _a.codParametro = _b.sent();
                        if (this.codParametro) {
                            this.getLink(this.codParametro, 'parametro');
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        /*   if (sessionStorage.getItem('identity-domCloud')) {
            this.searchUser()
          }else {
            this._router.navigate(['/inicio'])
            swal({
              type: 'warning',
              text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
              showConfirmButton: true,
              confirmButtonText: 'Aceptar',
              allowOutsideClick: false
            })
          } */
    }
    ValidarCertificadosComponent.prototype.ngOnInit = function () {
        this.identity = this._userService.getIdentity();
    };
    ValidarCertificadosComponent.prototype.buscar = function () {
        this.getLink(this.cod.value, 'dom');
    };
    ValidarCertificadosComponent.prototype.getLink = function (cod, vista) {
        var _this = this;
        this.spinner.show();
        console.log("Vista", vista);
        console.log("Codigo que se buscara", cod);
        this._cert.getLinkByCod(cod).subscribe(function (response) {
            console.log(response);
            if (response.data) {
                if (vista == 'dom') {
                    window.open(response.data, '_blank');
                }
                if (vista == 'parametro') {
                    window.open(response.data, "_self");
                }
            }
            else {
                console.log("no llego la info");
            }
            _this.spinner.hide();
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    ValidarCertificadosComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.dispatch(new FormActions.FormUpdate('0', ''));
                        sessionStorage.removeItem("identity-domCloud");
                        sessionStorage.removeItem("token-domCloud");
                        return [4 /*yield*/, this.claveUnicaService.logoutClaveUnica()];
                    case 1:
                        response = _a.sent();
                        console.log('Deslogeo exitoso:', response);
                        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
                            duration: 3000,
                        });
                        this.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    ValidarCertificadosComponent.prototype.openPerfil = function () {
        this.dialog.open(PerfilComponent);
    };
    ValidarCertificadosComponent.prototype.back = function () {
        this._router.navigate(['/inicio']);
    };
    ValidarCertificadosComponent.prototype.searchUser = function () {
        var _this = this;
        /* Buscar si existe en fm */
        var identityData = this._userService.getIdentity();
        var rut = identityData.rut + identityData.dv;
        this._userService.buscarUsuario(rutClean(rut)).subscribe(function (response) {
            if (response.message) {
                _this.spinner.hide();
                console.log(response);
            }
            if (response.register) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
            if (response.update) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    return ValidarCertificadosComponent;
}());
export { ValidarCertificadosComponent };
